// extracted by mini-css-extract-plugin
module.exports = {"featured-home-section":"featured-home-section_featured-home-section__8Gewm"};